import { useInitParams } from '@onramp/v2/client/contexts/initParams/InitParamsContext';
import { useGetAvailableNetworksForAsset } from '@onramp/v2/client/utils/destinationWallets/useGetAvailableNetworksForAsset';
import { useGetDefaultNetworkForAsset } from '@onramp/v2/client/utils/destinationWallets/useGetDefaultNetworkForAsset';
import { useDestinationWallets } from '@onramp/v2/client/views/guest/onramp/hooks/useDestinationWallets';
import { useOnrampInputStoreValue } from '@onramp/v2/client/views/onramp/state/store';

import { useOnrampActiveAsset } from './useOnrampActiveAsset';
import { useOnrampAssetsAndNetworks } from './useOnrampAssetsAndNetworks';

/** Do not call from v2 Guest. */
export const useOnrampActiveNetwork = () => {
  const assetsAndNetworks = useOnrampAssetsAndNetworks();
  const activeAsset = useOnrampActiveAsset();
  const { selectedNetwork } = useOnrampInputStoreValue();
  const { defaultNetwork: defaultNetworkParam } = useInitParams().initParams;
  const destinationWallets = useDestinationWallets();

  const getDefaultNetworkForAsset = useGetDefaultNetworkForAsset({
    defaultNetworkParam,
    destinationWallets,
    getAvailableNetworksQueryRef: assetsAndNetworks,
  });

  const getAvailableNetworksForAsset = useGetAvailableNetworksForAsset({
    destinationWallets,
    queryRef: assetsAndNetworks,
  });

  if (selectedNetwork !== undefined) {
    const availableNetworksForAsset = getAvailableNetworksForAsset(activeAsset.uuid);
    const selectedNetworkInfo = availableNetworksForAsset.find(
      ({ name }) => name === selectedNetwork,
    );

    if (selectedNetworkInfo === undefined) {
      // This could be caused if this function is called in v2 guest, if the
      // selected network isn't available in the user's location.
      throw new Error('Selected network info not available - this should not be possible.');
    }

    return selectedNetworkInfo;
  }

  const defaultNetworkInfo = getDefaultNetworkForAsset(activeAsset);
  return defaultNetworkInfo;
};
